import React, { useState } from "react";
import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ThankYou from "./main/ThankYou";
import Home from "./main/Home";

declare global {
  interface Window {
    fbq: (...args: any[]) => void;
  }
}

function App() {
  return (
    <div className="App relative font-poppins bg-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/thank-you" element={<ThankYou />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;